import { useState, useEffect } from "react";
import { useFormattedInput } from "../../hooks/useFormattedInput";

// Alta y edición de un cliente.
// Si recibe clientToEdit edita; si no, crea uno nuevo y la pantalla que
// lo llamó se encarga de abrir su ficha.
const ClientModal = ({ onSave, onClose, clientToEdit }) => {
  const editando = !!clientToEdit;

  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [direccion, setDireccion] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState(null);

  // Tope de lo que el cliente puede llegar a deber. Vacío = sin tope.
  const [limite, limiteMostrado, alCambiarLimite] = useFormattedInput(
    clientToEdit && clientToEdit.limite_credito ? clientToEdit.limite_credito : "",
    true
  );

  useEffect(() => {
    setNombre(clientToEdit ? clientToEdit.nombre_completo : "");
    setTelefono(clientToEdit ? clientToEdit.telefono : "");
    setDireccion(clientToEdit ? clientToEdit.direccion || "" : "");
  }, [clientToEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre.trim() || !telefono.trim()) {
      setError("El nombre y el teléfono son obligatorios.");
      return;
    }

    // Se bloquea el botón mientras se guarda, para que un doble clic no
    // cree el mismo cliente dos veces.
    setGuardando(true);
    setError(null);
    try {
      await onSave({
        ...(editando && { id: clientToEdit.id }),
        nombre_completo: nombre.trim(),
        telefono: telefono.trim(),
        direccion: direccion.trim(),
        limite_credito: limite === "" || isNaN(limite) ? null : limite,
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-cliente" onClick={(e) => e.stopPropagation()}>
        <h2>{editando ? "Editar cliente" : "Nuevo cliente"}</h2>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label className="form-label" htmlFor="cliente-nombre">
              Nombre completo
            </label>
            <input
              id="cliente-nombre"
              type="text"
              placeholder="Ana Solís Rodríguez"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              autoComplete="off"
              autoFocus
            />
          </div>

          <div className="campos-lado-a-lado">
            <div className="form-group">
              <label className="form-label" htmlFor="cliente-telefono">
                Teléfono
              </label>
              <input
                id="cliente-telefono"
                type="tel"
                placeholder="8888-0000"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                autoComplete="off"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="cliente-direccion">
                Dirección <span className="etiqueta-opcional">opcional</span>
              </label>
              <input
                id="cliente-direccion"
                type="text"
                placeholder="Grecia centro"
                value={direccion}
                onChange={(e) => setDireccion(e.target.value)}
                autoComplete="off"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="cliente-limite">
              Límite de crédito <span className="etiqueta-opcional">opcional</span>
            </label>
            <input
              id="cliente-limite"
              type="text"
              placeholder="Sin límite"
              value={limiteMostrado}
              onChange={alCambiarLimite}
              inputMode="decimal"
              autoComplete="off"
            />
            <span className="pista">
              Si se pone un tope, el sistema no deja registrarle ventas a crédito que lo
              superen: habría que cobrarlas de contado o pedirle un abono antes.
            </span>
          </div>

          {error && <p className="error-message">{error}</p>}

          <div className="modal-actions">
            <div className="modal-actions-buttons">
              <button type="button" className="btn-cancel" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="btn-submit" disabled={guardando}>
                {guardando
                  ? "Guardando..."
                  : editando
                  ? "Guardar cambios"
                  : "Crear cliente"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClientModal;
